

















import { Vue, Component, Inject } from "vue-property-decorator";

// Enums/Data
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IBasketProviderData } from "@/models/providers/baskets";
import { IShopProviderData } from "@/models/providers/basket/shop";

@Component({
  components: {
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class CheckoutTrustMessaging extends Vue {
  @Inject({ from: "shopProviderData" })
  public readonly $shopData!: () => IShopProviderData;

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  // Computed

  public get shopData() {
    return this.$shopData();
  }

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.BASKET_SUMMARY_FOOTER,
      objectId: this.$basketData().basketId
    };
  }
}
